import { useSetAtom } from 'jotai';

import { trackEvent } from '@zep/logger/tracking';

import { useQuizList } from '../../../components/useQuizList';
import { type AiGenerateDockSourceType } from '../consts/aiGenerateDock.const';
import { aiGenerateDockUiAtom } from '../stores/aiGenerateDock.atoms';
import { getRemainingQuizSlots } from '../utils/aiGenerateDockCount';
import { aiGenerateDockToasts } from '../utils/aiGenerateDockToasts';
import { type AiGeneratorDockPlace } from '../utils/events.quiz-ai-generator';

import { useAiGenerateDockCopy } from './useAiGenerateDockCopy';

/**
 * 생성기 입력창 열기 — 진입 카드·다시 열기가 모두 이걸 부른다. 문제가 20개로 가득 차 있으면 열지 않고
 * 상한 토스트(Figma 5-3)만 띄운다. 가득 찬 입력창은 없다 — 가득 참은 여기서 한 번만 판정한다.
 */
export const useRequestAiGenerateDock = () => {
  const { quizList } = useQuizList();
  const { copy } = useAiGenerateDockCopy();
  const dispatchUi = useSetAtom(aiGenerateDockUiAtom);

  return (
    sourceType: AiGenerateDockSourceType,
    place?: AiGeneratorDockPlace,
  ) => {
    const isFull = getRemainingQuizSlots(quizList.length) <= 0;
    // 사용자가 표면에서 누른 것만 센다 — 실행 결과로 다시 여는 것(표면 없음)은 누름이 아니다.
    if (place) {
      trackEvent('quiz_ai_generator_entry_click', {
        place: 'entry_card',
        source_type: sourceType,
        is_full: isFull,
        destination: 'generator_dock',
      });
    }
    if (isFull) {
      aiGenerateDockToasts.limit({ message: copy.locked, close: copy.close });
      return;
    }
    dispatchUi({ type: 'open', tab: sourceType, place });
  };
};
